export const useData = () => {
  const { t } = useI18n()

  const DEFAULT_ICON = {
    icon: {
      url: '/icons/icon_point.svg',
      alternative: '',
      width: '32',
      height: '32',
    },
  }
  const columnContent = () => ([
    t('wellbeingSale.forEmployers.column1'),
    t('wellbeingSale.forEmployers.column2'),
  ])

  const iconList = () => ([
    {
      text: t('wellbeingSale.forEmployers.bullet1'),
      ...DEFAULT_ICON,
    },
    {
      text: t('wellbeingSale.forEmployers.bullet2'),
      ...DEFAULT_ICON,
    },
    {
      text: t('wellbeingSale.forEmployers.bullet3'),
      ...DEFAULT_ICON,
    },
  ])

  const sliderData = [
    {
      image: '/images/wellbeing-sale/forEmployers/modal/1.png',
      title: t('wellbeingSale.forEmployers.modalItem1Title'),
      description: t('wellbeingSale.forEmployers.modalItem1Paragraph'),
      label: t('wellbeingSale.forEmployers.modalItem1Label'),
    },
    {
      image: '/images/wellbeing-sale/forEmployers/modal/2.png',
      title: t('wellbeingSale.forEmployers.modalItem2Title'),
      description: t('wellbeingSale.forEmployers.modalItem2Paragraph'),
      label: t('wellbeingSale.forEmployers.modalItem2Label'),
    },
    {
      image: '/images/wellbeing-sale/forEmployers/modal/3.png',
      title: t('wellbeingSale.forEmployers.modalItem3Title'),
      description: t('wellbeingSale.forEmployers.modalItem3Paragraph'),
      label: t('wellbeingSale.forEmployers.modalItem3Label'),
    },
    {
      image: '/images/wellbeing-sale/forEmployers/modal/4.png',
      title: t('wellbeingSale.forEmployers.modalItem4Title'),
      description: t('wellbeingSale.forEmployers.modalItem4Paragraph'),
      label: t('wellbeingSale.forEmployers.modalItem4Label'),
    },
    {
      image: '/images/wellbeing-sale/forEmployers/modal/5.png',
      title: t('wellbeingSale.forEmployers.modalItem5Title'),
      description: t('wellbeingSale.forEmployers.modalItem5Paragraph'),
      label: t('wellbeingSale.forEmployers.modalItem5Label'),
    },
    {
      image: '/images/wellbeing-sale/forEmployers/modal/6.png',
      title: t('wellbeingSale.forEmployers.modalItem6Title'),
      description: t('wellbeingSale.forEmployers.modalItem6Paragraph'),
      label: t('wellbeingSale.forEmployers.modalItem6Label'),
    },
  ]

  return {
    iconList,
    columnContent,
    sliderData,
  }
}
